import * as zod from 'zod';

import { Tags } from '../utils/types';

export type tagSchemaData = { tagValue: string };

export const getValidationCreateTagSchema = (tags: Tags) =>
  zod.object({
    tagValue: zod
      .string({ required_error: 'Campo obrigatório' })
      .min(3, 'Campo deve conter no mínimo 3 caracteres')
      .max(30, 'Campo deve conter no máximo 30 caracteres')
      .refine((value) => value.replace(/\s+/g, '').length >= 3, {
        message: 'Campo deve conter no mínimo 3 caracteres',
      })
      .refine(
        (value: string) =>
          !tags.list.some((tag) => tag.tagName.toUpperCase() === value.toUpperCase()),
        {
          message: 'Tag duplicada, verifique e tente novamente.',
        }
      ),
  });
